export enum NetworkStatus {
    OutOfNetwork = 0,
    InNetwork = 1,
    AdditionalInfo = 2,
    NotAvailable = 3,
    SkipGroup = 4,
}

export enum Network {
    PPO = 'ppo',
    HMO = 'hmo',
    EPO = 'epo',
    POS = 'pos',
}

export enum ContainerSteps {
    Service = 'service',
    Plan = 'plan',
    MentalHealth = 'mental-health',
    Network = 'network',
    MedicalGroup = 'medical-group',
    PCP = 'pcp',
    InNetwork = 'in-network',
    OutOfNetwork = 'out-of-network',
}

export enum ModalTypes {
    AutoClaims = 'auto-claims',
    WorkersComp = 'workers-comp',
    TravelersInsurance = 'travelers-insurance',
    MedicalGroupIPA = 'medical-group-ipa',
    NotSure = 'not-sure',
}

export type InsuranceService = {
    _id: string;
    name: string;
    definition: string;
    order: number;
};

export type PlanService = {
    name: string;
    serviceStatus: NetworkStatus;
}

export type MentalHealth = {
    commercial: NetworkStatus;
    medicareAdvantage: NetworkStatus;
    mediCal: NetworkStatus;
}

export type InsurancePlan = {
    _id: string;
    name: string;
    services: PlanService[];
    nameVariations: string[];
    tradingPartnerServiceId: string;
    epicName: string;
    exceptions: string[];
    mentalHealth: MentalHealth;
    createdAt: string;
    updatedAt: string;
    ppo: NetworkStatus;
    hmo: NetworkStatus;
    epo: NetworkStatus;
    pos: NetworkStatus;
};

export type EpicName = {
    insurance: string;
    name: string;
}

export type MedicalGroup = {
    _id: string;
    name: string;
    services: PlanService[];
    epicNames: EpicName[];
    exceptions: string[];
    counties: string[];
    createdAt: string;
    updatedAt: string;
}

export type Provider = {
    _id: string;
    name: string;
    firstName: string;
    lastName: string;
    image: string;
}

export type DataResponse = {
    services: InsuranceService[];
    plans: InsurancePlan[];
    groups: MedicalGroup[];
    providers: Provider[];
}

export type ModalProps = {
    open: boolean;
    handleClose: () => void;
};

export type SelectedNetwork = {
    network: Network;
    status: NetworkStatus;
}
